import * as types from '../../app/employer/redux/constants';

export function privilegeFetchSuccess(privileges) {
   return {
      type: types.PRIVILEGES_FETCH_SUCCESS,
      payload: {
         privileges,
      },
   };
}
